/* eslint-disable */
export interface OrderedListData {
  /** Indentation level from 0-4. */
  indentation: number;
  /** Offset level from 0-4. */
  offset?: number;
  /** List start number. */
  start?: number;
}

export interface BulletedListData {
  /** Indentation level from 0-4. */
  indentation: number;
  /** Offset level from 0-4. */
  offset?: number;
}

const baseOrderedListData: object = { indentation: 0 };

export const OrderedListData = {
  fromJSON(object: any): OrderedListData {
    const message = { ...baseOrderedListData } as OrderedListData;
    message.indentation =
      object.indentation !== undefined && object.indentation !== null
        ? Number(object.indentation)
        : 0;
    message.offset =
      object.offset !== undefined && object.offset !== null ? Number(object.offset) : undefined;
    message.start =
      object.start !== undefined && object.start !== null ? Number(object.start) : undefined;
    return message;
  },

  toJSON(message: OrderedListData): unknown {
    const obj: any = {};
    message.indentation !== undefined && (obj.indentation = Math.round(message.indentation));
    message.offset !== undefined && (obj.offset = message.offset);
    message.start !== undefined && (obj.start = message.start);
    return obj;
  },
};

const baseBulletedListData: object = { indentation: 0 };

export const BulletedListData = {
  fromJSON(object: any): BulletedListData {
    const message = { ...baseBulletedListData } as BulletedListData;
    message.indentation =
      object.indentation !== undefined && object.indentation !== null
        ? Number(object.indentation)
        : 0;
    message.offset =
      object.offset !== undefined && object.offset !== null ? Number(object.offset) : undefined;
    return message;
  },

  toJSON(message: BulletedListData): unknown {
    const obj: any = {};
    message.indentation !== undefined && (obj.indentation = Math.round(message.indentation));
    message.offset !== undefined && (obj.offset = message.offset);
    return obj;
  },
};
